<!--
 * @Author:
 * @Description: OCR配置
-->
<template>
  <el-card class="h-full overflow-auto" :body-style="{ padding: '20px', height: '100%' }">
    <el-row>
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-input
        class="w-200px ml-10px mr-10px"
        v-model="search.identifyContent"
        placeholder="识别内容"
        size="small"
        clearable
      />
      <el-input
        class="w-200px mr-10px"
        v-model="search.replaceContent"
        placeholder="替换内容"
        size="small"
        clearable
      />
      <el-select
        class="w-200px mr-10px"
        v-model="search.isEnabled"
        placeholder="状态"
        size="small"
        clearable
      >
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="searchList">搜索</el-button>
      <el-button
        type="primary"
        :disabled="!$hasAccess('create')"
        @click="handleOperateForm('create')"
      >
        新增</el-button
      >
      <el-button type="primary" @click="toUpdate"> 更新</el-button>
      <el-button type="danger" :disabled="!$hasAccess('delete')" @click="toDelete(ids)"
        >删除</el-button
      >
    </el-row>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      class="mt-20px"
      height="calc(100% - 104px)"
      :highlight-current-row="true"
      @selection-change="selectionChange"
      @sort-change="sortChange"
      ref="table"
      row-key="id"
      stripe
      border
    >
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        label="识别内容"
        prop="identifyContent"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="替换内容"
        prop="replaceContent"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="范围"
        prop="scopeName"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="状态" prop="isEnabled" sortable show-overflow-tooltip>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isEnabled" active-color="#13ce66" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createdTime" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleOperateForm('update', scope.row)">编辑</el-button>
          <el-button size="mini" @click="toDelete([scope.row.id])">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right my-20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>

    <!-- 表单弹框 -->
    <el-dialog
      :title="formTitle"
      :visible.sync="formVisible"
      class="small-dialog"
      :close-on-click-modal="false"
      v-dialogDrag
      @close="closeFormDialog"
    >
      <el-form ref="baseForm" label-width="150px" :model="formData" :rules="rules">
        <el-form-item label="识别内容" prop="identifyContent">
          <el-input
            v-model="formData.identifyContent"
            class="w-full"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="替换内容" prop="replaceContent">
          <el-input
            v-model="formData.replaceContent"
            class="w-full"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="范围" prop="scope">
          <el-select
            class="w-full"
            v-model="formData.scope"
            placeholder="请选择"
            multiple
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="item in documentTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="isEnabled">
          <el-switch v-model="formData.isEnabled" active-color="#13ce66"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeFormDialog">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveForm">保存</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import documentConfigService from '@/services/documentConfigService'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'OCRConfigure',
  components: { selectStandardId },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      classTypeList: [],
      search: {
        identifyContent: '',
        replaceContent: '',
        isEnabled: null,
      },
      statusList: [
        { name: '开启', value: true },
        { name: '关闭', value: false },
      ],
      ids: [],
      selectionList: [],
      tableLoading: false,
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      formVisible: false,
      formData: {
        identifyContent: '',
        replaceContent: '',
        scope: [],
        isEnabled: true,
      },
      rules: {
        identifyContent: [{ required: true, message: '请输入识别内容', trigger: 'blur' }],
        replaceContent: [{ required: true, message: '请输入替换内容', trigger: 'blur' }],
        scope: [{ required: true, message: '请选择范围', trigger: 'change' }],
      },
      formTitle: '',
      documentTypeList: [],
      saveLoading: false,
    }
  },
  watch: {},
  created() {
    this.searchList()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.formData.standardId = val
      this.searchList()
    },
    // 表格多选
    selectionChange(val) {
      this.selectionList = val
      this.ids = _.map(val, (item) => {
        return item.id
      })
    },
    // 搜索
    searchList() {
      this.page.pageNo = 1
      this.getTableList()
    },
    // 获取表格数据
    async getTableList() {
      this.tableLoading = true
      const res = await documentConfigService.getOcrDataReplaceList({
        ...this.search,
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.getTableList()
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo
      this.getTableList()
    },
    // 排序
    sortChange() {},
    // 表单操作
    handleOperateForm(type, row) {
      this.formVisible = true
      this.getdocumentTypeList()
      switch (type) {
        case 'create':
          this.formTitle = '新增'
          break
        case 'update':
          this.formTitle = '编辑'
          this.getFormDetail(row)
          break
        case 'view':
          this.formTitle = '查看'
          break
        default:
          break
      }
    },
    // 表单保存
    saveForm() {
      this.$refs.baseForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          if (this.formData.id) {
            // 编辑
            const res = await documentConfigService.updateOcrDataReplace(this.formData)
            if (res && res.code === 0) {
              this.$message.success('保存成功')
              this.searchList()
              this.closeFormDialog()
            }
          } else {
            // 新增
            const res = await documentConfigService.addOcrDataReplace(this.formData)
            if (res && res.code === 0) {
              this.$message.success('新增成功')
              this.searchList()
              this.closeFormDialog()
            }
          }
          this.saveLoading = false
        }
      })
    },
    // 获取表单详情
    async getFormDetail(row) {
      const res = await documentConfigService.getOcrDataReplaceById({
        id: row.id,
      })
      if (res && res.code === 0 && res.data) {
        this.formData = res.data
        this.getdocumentTypeList()
      }
    },
    // 获取文档类型下拉数据
    async getdocumentTypeList() {
      const res = await documentConfigService.getDocumentTypeClass({
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.documentTypeList = res.data
      }
    },
    // 更新
    toUpdate() {
      this.$confirm('确定更新文档解析吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await documentConfigService.ocrManualExecute()
        if (res && res.code === 0) {
          this.$message.success('更新成功')
          this.searchList()
        }
      })
    },
    // 删除
    toDelete(ids) {
      if (!ids.length) {
        this.$message.info('请选择要删除的数据')
        return
      }
      this.$confirm('确认要删除所选数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await documentConfigService.deleteOcrDataReplace(ids)
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          this.searchList()
        }
      })
    },
    // 关闭表单弹框
    closeFormDialog() {
      this.formVisible = false
      this.formData = this.$options.data().formData
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
